import axios from "axios";

const fetchCdes = (
  search = "",
  currentPage = 1,
  pageSize = 10,
  filterBy = "",
  filterValue = ""
) =>
  axios.get("/api/v1/cde_definitions", {
    params: {
      search,
      page: currentPage,
      per_page: pageSize,
      filter_by: filterBy,
      filter_value: filterValue,
    },
  });

const getCde = id => axios.get(`/api/v1/cde_definitions/${id}`);

const createCde = payload =>
  axios.post("/api/v1/cde_definitions", { cde_definition: payload });

const editCde = (id, payload) =>
  axios.put(`/api/v1/cde_definitions/${id}`, payload);

const deleteCdes = ids => {
  const params = new URLSearchParams(ids.map(id => ["ids[]", id]));
  return axios.delete(`/api/v1/cde_definitions/1?${params.toString()}`);
};

const fetchSummary = payload =>
  axios.get(`/api/v1/cde_definitions/summary_graph?limit_from=${payload}`);

const cdesApi = {
  fetchCdes,
  getCde,
  createCde,
  editCde,
  deleteCdes,
  fetchSummary,
};

export default cdesApi;
